import { useEffect, useState } from "react";
import { useTranslations } from "../../i18n";

/**
 * Stripe est revenu sur le widget en pleine page, hors du site du studio
 * (TWINT peut sortir de l'iframe). On renvoie l'eleve sur la page du studio
 * d'ou elle a reserve, avec « #bz-booking= » : embed.js y rouvre le widget sur
 * la confirmation. Ici, pas de jeton (stockage partitionne par site) : l'API
 * publique ne donne que l'adresse, et seulement sur un domaine du studio.
 */
export function ReturnToStudio({ bookingId }: { bookingId: string | null }) {
  const t = useTranslations("common");
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    if (!bookingId) return;
    fetch(`/api/widget/public/checkout-return/${encodeURIComponent(bookingId)}`, {
      credentials: "omit",
    })
      .then((res) => res.json())
      .then((data: { hostUrl?: string | null }) => {
        if (!data.hostUrl) throw new Error("No host page");
        window.location.replace(`${data.hostUrl}#bz-booking=${encodeURIComponent(bookingId)}`);
      })
      .catch(() => setFailed(true));
  }, [bookingId]);

  return (
    <div className="mx-auto flex min-h-[60vh] max-w-md flex-col items-center justify-center gap-2 px-4 text-center">
      <p className="text-base font-semibold text-ink">
        {failed || !bookingId ? t("paymentReceived") : t("paymentReturning")}
      </p>
      {(failed || !bookingId) && <p className="text-sm text-ink-soft">{t("paymentReceivedHint")}</p>}
    </div>
  );
}
